import { SharingResult, SharingResultDto } from '../..';
import { Mapper } from '../../../@harmony';

export class SharintResultDtoToSharingResultMapper
  implements Mapper<SharingResultDto, SharingResult>
{
  public map(from: SharingResultDto): SharingResult {
    return new SharingResult(from.domain, from.groups, from.publicAccess, from.users);
  }
}
